import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faUnlockKeyhole, faSquareCheck, faEyeSlash, faEye, faEnvelope, faLock, faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import {finalize} from 'rxjs';
import { validateAllFormFields } from '../../../common/utils';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { RoleService } from '../../services/role.service';
import {BusyService} from '../../services/busy.service';

@Component({
    selector: 'app-login',
    imports: [CommonModule, FontAwesomeModule, ReactiveFormsModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  username: string = '';
  password: string = '';
  isPasswordVisible:Boolean = false;
  loginForm: FormGroup;
  currentYear = new Date().getFullYear();
    isLoggingIn = false;

  ngOnInit(): void {
    this.authService.logout();
  }

  constructor(private http: HttpClient,
    private router: Router,
    private apiService: ApiService,
    library: FaIconLibrary,
    private toastr: ToastrService,
    private authService: AuthService,
    private roleService: RoleService,
              private busyService: BusyService,
    fb: FormBuilder
    ) {
    library.addIcons(faUnlockKeyhole, faSquareCheck, faEyeSlash,faEye, faEnvelope, faLock, faArrowRightToBracket)

    this.loginForm = fb.group({
      username: ['', Validators.required],
      password: ['',[Validators.required]],
    })
  }

  onSubmit() {
      if (this.isLoggingIn) {
          return;
      }

    if (this.loginForm.valid) {
        const formData = new FormData();
      formData.append('username', this.loginForm.value.username)
      formData.append('password', this.loginForm.value.password)

        this.isLoggingIn = true;
        this.busyService.busy();

        this.apiService.logIn(formData).pipe(
            finalize(() => {
                this.isLoggingIn = false;
                this.busyService.idle();
            }),
        ).subscribe({
        next: (response) => {
          this.authService.storeTempLogin(response.access, response.refresh, response.user);
          if (response.user.is_mobile_verified){
              this.authService.saveToLocalStorage();
            this.toastr.success('Login successful.', 'Success', {
              timeOut: 3000,
              easeTime: 300,
            });
            this.router.navigateByUrl(this.roleService.getDefaultRoute(response.user.groups));
          } else {
              this.router.navigate(['/verify-mobile-otp']);
          }
        },
        error: (err) => {
          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          } else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error(err.error?.detail || 'Login failed. Please try again.', 'Error');
          } else if (err.status === 0) {
              this.toastr.error('Network error. Please check your connection and try again.', 'Error');
          }
        }
      });
    }
    else{
      validateAllFormFields(this.loginForm)
    }
}
  togglePasswordVisibility(){
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  forgotPassword(){
    this.router.navigate(['forgot-password']);
  }
}
